import type { CustomerCatalogImage, CustomerCatalogProduct, CustomerCatalogVariant } from "../../api/customer/customerCatalogApi";

export const variantLabel = (variant: CustomerCatalogVariant): string => {
	const options = [variant.option1, variant.option2, variant.option3].filter((option): option is string => !!option);
	if (options.length > 0) return options.join(" / ");

	return variant.title || "Default";
};

export const primaryImage = (images: CustomerCatalogImage[]): CustomerCatalogImage | undefined =>
	images.find((image) => image.is_primary) ??
	[...images].sort((a, b) => a.position - b.position)[0];

export const initialVariant = (product: CustomerCatalogProduct): CustomerCatalogVariant | undefined =>
	product.variants.find((variant) => variant.is_default_variant) ?? product.variants[0];

export const formatPrice = (price: string | number | null | undefined): string => {
	if (price === null || price === undefined || price === "") return "—";

	const amount = Number(price);
	return Number.isFinite(amount) ? `$${amount.toFixed(2)}` : "—";
};

// CU-86d45b2z1: zero available is out of stock, never hidden.
export const isVariantAvailable = (variant: CustomerCatalogVariant): boolean => variant.available > 0;
